/* 第三方定制首页 */
import { orgMixin, packageMixin } from '@/mixins'
import { http, HTTP_URL, activityHandle, getOrgList } from '@/assets/js/api'
import Navigation from '@/components/index/Navigation' // 场景快捷入口
import PackageItem from '@/components/thirdPartyIndex/PackageItem'
import OrgItem from '@/components/thirdPartyIndex/OrgItem'
import CouponPopup from '@/components/thirdPartyIndex/CouponPopup'
import { mapGetters } from 'vuex'

import { jumpLink, MtaH5ClickStat } from '@/assets/js/util'
import NoResult from '@/components/no-result' // 列表为空
import Banner from '@/components/userCenter/Banner' // banner位

const keepalivePages = [
  'packageListV2',
  'orgListV2',
  'package-org-v2',
  'org-detail',
  'package-detail-v2'
]
export const thirdPartyIndexMixin = {
  components: {
    Navigation,
    PackageItem,
    OrgItem,
    CouponPopup,
    NoResult,
    Banner
    // Shortcut
  },
  mixins: [packageMixin, orgMixin],
  data () {
    return {
      cos_prefix,
      taifuli,
      sceneEntry: [],
      showPopup: false,
      showBuoy: true,
      packageList: [],
      orgList: [],
      more_button_channel_code: {},
      sceneEntrySquare: [],
      privateEntry: {},
      loading1: true,
      loading2: true,
      banner: [],
      eventId: 'thirdPartyIndex',
      operationName: 'operation'
      // shortcut: JSON.parse(newH5IndexProps.operation3) || []
    }
  },
  activated () {
    this.packageList = []
    this.orgList = []
    this.initData()
  },
  methods: {
    initData () {
      this._getHotPackage()
      this.getTaifuliInfo()
      // this._getOrgList()
    },
    getTaifuliInfo () {
      activityHandle({
        activity_type: 'third_party_index',
        method: 'buttonList',
        city_id: this.currentCity.city_id,
        ...this.$route.query
      }).then(res => {
        // res = {"code":200,"data":{"banner":[{"title":"泰福利banner","desc":null,"type":1,"pic":"\/upload\/imagelist\/ori\/761566a96abda91b618d3dd49c7b1a63.jpeg","url":""},{"title":"对比功能","desc":null,"type":1,"pic":"\/upload\/imagelist\/ori\/0aaf74d8bafc28402938d6761fb96060.jpeg","url":"http:\/\/test.daishutijian.com\/tijian3\/apps\/wechat\/h5#\/common-activity\/28?channel=0001_05"},{"title":"服务商加盟","desc":null,"type":1,"pic":"\/upload\/imagelist\/ori\/54621e860c49d3f0b86b5b5aad5c28c1.png","url":"https:\/\/test.daishutijian.com\/tijian\/apps\/wechat\/h5#\/agent-joining"},{"title":"逢6活动","desc":null,"type":1,"pic":"\/upload\/imagelist\/ori\/72982d23aac12094d53aa966e96ec563.jpeg","url":"https:\/\/test.daishutijian.com\/tijian\/apps\/wechat\/h5#\/ccbDiscount"},{"title":"买体检送积分","desc":null,"type":1,"pic":"\/upload\/imagelist\/ori\/97c065cee9d62d8f67d78f779f52df59.png","url":"http:\/\/test.daishutijian.com\/tijian3\/apps\/wechat\/h5#\/common-activity\/80"}],"opt1":[{"title":"预付款预","pic":"\/upload\/imagelist\/ori\/436633dc38e4257ebbac7de0b8fee946.png","url":"https:\/\/apps.daishutijian.com\/wechat\/h5#\/questionnaire\/home"},{"title":"团检企业","pic":"\/upload\/imagelist\/ori\/674485cff7193d51ade473746e8cd142.png","url":"https:\/\/apps.daishutijian.com\/wechat\/h5#\/medicalcard-list"},{"title":"袋鼠商城","pic":"\/upload\/imagelist\/ori\/e642d4a5f19ba12e9997035a9876a7d4.png","url":"http:\/\/www.baidu.com"},{"title":"长辈体检","pic":"\/upload\/imagelist\/ori\/8b969fe622556b2f3052cec251f0a3e5.png","url":"https:\/\/apps.daishutijian.com\/wechat\/h5#\/package-list?package_class=6,7,42,126&sceneEntry=1"}],"opt2":[{"title":"111","desc":"","url":"https:\/\/apps.daishutijian.com\/wechat\/h5#\/questionnaire\/home","pic":"\/upload\/imagelist\/ori\/325537e044a07d8123e4a2429aaeef35.png"},{"title":"袋鼠商城","desc":"","url":"http:\/\/www.baidu.com","pic":"\/upload\/imagelist\/ori\/6ee19e6e3e5a9d7d69d337c82740a94c.png"},{"title":"私人定制","desc":"","url":"https:\/\/apps.daishutijian.com\/wechat\/h5#\/questionnaire\/home","pic":"\/upload\/imagelist\/ori\/66cfa86c52f01ea3ee9a8b9bc6285c31.png"}],"opt3":[{"title":"111","desc":"","url":"","pic":"\/upload\/imagelist\/ori\/866713ecc911eb057078af1b297da531.png"}]},"msg":"查询完成"}
        if (res.code === 200) {
          this.banner = res.data.banner
          this.sceneEntry = res.data.opt1
          this.sceneEntrySquare = res.data.opt2
          this.privateEntry =
            res.data.opt3 && res.data.opt3[0] && res.data.opt3.length > 0
              ? res.data.opt3[0]
              : {}
          // 控制弹窗
          const SHOW_TAIFULI_POPOP_KEY = 'SHOW_TAIFULI_POPOP_KEY'
          this.showPopup = +localStorage.getItem(SHOW_TAIFULI_POPOP_KEY) === 0
          localStorage.setItem(SHOW_TAIFULI_POPOP_KEY, 1)
        }
      })
    },
    _getHotPackage () {
      activityHandle({
        activity_type: 'third_party_index',
        method: 'packageList',
        city_id: this.currentCity.city_id,
        ...this.$route.query
      }).then(res => {
        if (res.code === 200) {
          this.packageList = res.data.package_list
          this.orgList = res.data.org_list
          this.more_button_channel_code = res.data.more_button_channel_code
          this.loading1 = false
        }
      })
    },
    _getOrgList () {
      getOrgList({
        city_id: this.currentCity.city_id,
        isHome: 1
      }).then(res => {
        if (res.code === 200) {
          this.orgList = res.data
          if (res.data.length > 5) {
            this.orgList = res.data.splice(0, 5)
          }
          this.loading2 = false
        }
      })
    },
    // 查看更多
    more (type) {
      let url = {
        org: {
          path: '/org-list',
          query: {
            channel: this.more_button_channel_code[type]
          }
        },
        package: {
          path: '/package-list',
          query: {
            channel: this.more_button_channel_code[type]
          }
        }
      }
      this.$router.push(url[type])
    },
    linkto (item, index, level) {
      // 埋点
      let obj = {}
      let key = this.operationName + (level * 5 + index + 1)
      obj[key] = 'true'
      MtaH5ClickStat(obj, this.eventId)
      // 跳转
      jumpLink({ vm: this, url: item.url })
    },
    selectOrg (item) {
      this.linkOrg({ item, query: { channel: item.channel_code } })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (keepalivePages.indexOf(to.name) > -1) {
      from.meta.isBack = true
    } else {
      from.meta.isBack = false
    }
    next()
  },
  computed: {
    ...mapGetters(['currentCity'])
  }
}
